'use client';
import { styled } from '@mui/material/styles';
import { useGridSelector } from '@mui/x-data-grid-pro';
import type { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { gridClasses } from '@mui/x-data-grid';
import { useGridApiContext } from '../hooks/utils/useGridApiContext';
import { gridFormulaA1PositionContextSelector } from '../hooks/features/formula/gridFormulaPositionContext';

const GridFormulaRowNumberRoot = styled('div', {
  name: 'MuiDataGrid',
  slot: 'FormulaRowNumberCell',
})(({ theme }) => ({
  width: '100%',
  textAlign: 'center',
  color: theme.palette.text.secondary,
  fontVariantNumeric: 'tabular-nums',
  userSelect: 'none',
}));

/**
 * Cell of the autogenerated row-number column. Displays the row's 1-based view
 * position from the shared A1 position context — the exact number
 * `ROW_POSITION(n)`/A1 references resolve to. Autogenerated rows (group headers,
 * footers) have no position and render blank.
 */
function GridFormulaRowNumberCell(props: GridRenderCellParams) {
  const apiRef = useGridApiContext();
  const positionContext = useGridSelector(apiRef, gridFormulaA1PositionContextSelector);
  const position = positionContext.getPositionOfRowId(props.id);
  if (position === undefined) {
    return null;
  }
  return (
    <GridFormulaRowNumberRoot className={gridClasses.formulaRowNumberCell}>
      {position}
    </GridFormulaRowNumberRoot>
  );
}

export { GridFormulaRowNumberCell };

export const renderFormulaRowNumberCell = (params: GridRenderCellParams) => (
  <GridFormulaRowNumberCell {...params} />
);
